import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import useMakeRequest from "../../utils/ApiHelper";
import { POSTAPI } from "../../config/Api";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import PageLoadingShell from "../layout/PageLoadingShell";
import ListPageSkeleton from "../layout/ListPageSkeleton";
import { Modal } from "react-bootstrap";
import QuotationEditMessage from "../../Modal/QuotationEditMessage";
import QuotationEdit from "../../Modal/QuotationEdit";
import NewAddress from "../../Modal/NewAddress";
import Swal from "sweetalert2";
import exclamationIcon from "../../Assets/images/exclamation.svg";
import exclamationYellowIcon from "../../Assets/images/exclamation-yellow.svg";
import gridIcon from "../../Assets/images/grid-icon.svg";
import {
  CurrencyConvertHistory,
  CurrencyIcon,
  formatDisplayLongDate,
  getDate,
  getFromStorage,
  getPriceHelper,
} from "../../utils/Helper";
import Productdelete from "../../Modal/Productdelete";
import ChatModal from "../../Modal/ChatModal";
import QuantityHistory from "../../Modal/QuantityHistory";
import { toast } from "react-toastify";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { StorageConstant } from "../../constants/Constants";
import { Routes as AppRoutes } from "../../constants/RouteConstants";
import { socket } from "../../utils/Socket";
import moment from "moment";
import { QuotationStatusBadge } from "./view-quotation/QuotationStatusBadge";
import { QuotationItemCard } from "./view-quotation/QuotationItemCard";
import { QuotationItemsToolbar } from "./view-quotation/QuotationItemsToolbar";
import { QuotationItemsTable } from "./view-quotation/QuotationItemsTable";
import { renderQuotationItemCards } from "./view-quotation/renderQuotationItemCards";
import { QuotationTableQtyStepper } from "./view-quotation/QuotationTableQtyStepper";
import {
  formatAddressListRow,
  formatQuotationAddress,
  formatQuotedQtyDisplay,
  getQuotedLineExtendedAmount,
  isQuoteLineUnavailable,
  quotationHasLineAdminPricing,
  quotationHasPriceBreakdownValues,
  QUOTE_UNAVAILABLE_DASH,
  parseChargeLineAmount,
  parseOtherChargesLines,
  quoteRowSearchBlob,
} from "./view-quotation/helpers";
import downloadButtonIcon from "../../Assets/images/download button.svg";
import { QUOTE_SUCCESS_LOGO_URL } from "../../utils/quoteSuccessLogo";
import listIcon from "../../Assets/images/list-icon.svg";
import { buildSortedShippingDisplayRows } from "../../utils/shippingDisplay";
import { openQuotationPdfInNewTab } from "../../utils/openQuotationPdf";
import "./MyquotationView.scss";

type ViewMode = "list" | "grid";

type LineRow = {
  kind: "api" | "pending";
  res: any;
  displayNo: number;
};

function MyquotationView() {
  const { id } = useParams();
  const brandList = useMakeRequest();
  const quotationView = useMakeRequest();
  const quotationNotes = useMakeRequest();
  const quotationNotesSeen = useMakeRequest();
  const quotationReject = useMakeRequest();
  const QuotationUpdate = useMakeRequest();
  const ProductAdd = useMakeRequest();
  const addressListDelivery = useMakeRequest();
  const addressDeliveryUpdate = useMakeRequest();
  const shippingListDelivery = useMakeRequest();

  const [showMessage, setShowMessage] = useState(false);
  const [editshow, setEditShow] = useState(false);
  const [sendData, setSendData] = useState({});
  const [productdelete, setProductDelete] = useState(false);
  const [chatshow, setChatshow] = useState(false);
  const [historyShow, setHistoryShow] = useState(false);
  const [quotesEdit, setQuotesEdit] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [otherChargesModalOpen, setOtherChargesModalOpen] = useState(false);
  const [notesViewOpen, setNotesViewOpen] = useState(false);
  const [hasUnseenNotes, setHasUnseenNotes] = useState(false);
  const [deliverySectionVisible, setDeliverySectionVisible] = useState(false);
  const [deliveryPanelOpening, setDeliveryPanelOpening] = useState(false);
  const [deliveryPick, setDeliveryPick] = useState<any>(null);
  const [deliveryPickError, setDeliveryPickError] = useState("");
  const [deliveryShippingPick, setDeliveryShippingPick] = useState<string>("");
  const [deliverySelectionTouched, setDeliverySelectionTouched] = useState(false);
  const [deliveryUpdateConfirmed, setDeliveryUpdateConfirmed] = useState(false);
  const [appliedAddressId, setAppliedAddressId] = useState<string>("");
  const [appliedShippingId, setAppliedShippingId] = useState<string>("");
  const [appliedAddressLabel, setAppliedAddressLabel] = useState<string>("");
  const [deliveryNewAddressInline, setDeliveryNewAddressInline] = useState(false);
  const [pendingCreatedAddressId, setPendingCreatedAddressId] = useState<string>("");

  const [historyData, setHistoryData] = useState([]);
  const [currency, setCurrency] = useState<"USD" | "PHP" | "EUR">("USD");
  const [quotes, setQuotes] = useState<any>([]);
  const [s_no, setS_no] = useState("");

  const [viewMode, setViewMode] = useState<ViewMode>("list");
  const [itemSearch, setItemSearch] = useState("");
  /** List table: show inline +/- only for this quote line id after Edit is clicked. */
  const [tableQtyEditingQuoteId, setTableQtyEditingQuoteId] = useState<string | number | null>(null);
  /** Show Update when table qty differs from saved baseline (hides again if user restores original qty). */
  const [tableQtyStepperUsed, setTableQtyStepperUsed] = useState(false);
  const [pendingQtyChangedKeys, setPendingQtyChangedKeys] = useState<string[]>([]);
  const [approveNavigating, setApproveNavigating] = useState(false);
  const suppressAddressSuccessPopupRef = useRef(false);
  const combinedUpdateQuoteIdRef = useRef<string | null>(null);
  const productAddUpdateOnlyRef = useRef(false);

  const navigate = useNavigate();
  const location = useLocation();
  const [pendingAnotherProduct, setPendingAnotherProduct] = useState<any>(() => {
    const state = location.state as { pendingAnotherProduct?: any } | null;
    return state?.pendingAnotherProduct ?? null;
  });
  const [pendingQuantityEdits, setPendingQuantityEdits] = useState<any>(() => {
    const state = location.state as { pendingQuantityEdits?: any } | null;
    return state?.pendingQuantityEdits ?? null;
  });
  const [pendingDeliveryEdit, setPendingDeliveryEdit] = useState<any>(() => {
    const state = location.state as { pendingDeliveryEdit?: any } | null;
    return state?.pendingDeliveryEdit ?? null;
  });
  const [pendingDeletedItems, setPendingDeletedItems] = useState<any[]>(() => {
    const state = location.state as { pendingDeletedItems?: any[] } | null;
    const deletedItems = state?.pendingDeletedItems;
    return Array.isArray(deletedItems) ? deletedItems : [];
  });
  const anotherProduct = pendingAnotherProduct;

  const showQuoteUpdatedHomePopup = (options?: {
    autoCloseAfterMs?: number;
    quoteId?: string;
    redirectToHome?: boolean;
  }) => {
    const quoteIdForModal =
      options?.quoteId ??
      quotationData?.quotation_id ??
      quotationView?.data?.data?.quotation_id ??
      id ??
      "—";
    const title =
      LanguageConstants?.VIEW_QUOTE_UPDATED_SUCCESS_TITLE ?? "Your quote has been updated";
    const body =
      LanguageConstants?.VIEW_QUOTE_UPDATED_SUCCESS_BODY ??
      "A request has been sent to admin. We're reviewing the details and will notify you as soon as your quote is ready.";
    const autoCloseAfterMs = options?.autoCloseAfterMs ?? 5000;
    void Swal.fire({
      html: `
        <div class="manual-quote-success-modal">
          <img src="${QUOTE_SUCCESS_LOGO_URL}" alt="Quote N Buy" class="manual-quote-success-modal__logo" width="128" height="128" decoding="async" />
          <h2 class="manual-quote-success-modal__title manual-quote-success-modal__title--updated">${title}</h2>
          <p class="manual-quote-success-modal__id">Quote ID: ${quoteIdForModal}</p>
          <p class="manual-quote-success-modal__desc">${body}</p>
        </div>
      `,
      showConfirmButton: true,
      confirmButtonText: LanguageConstants?.HOME ?? "Home",
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      backdrop: "rgba(17, 24, 39, 0.45)",
      timer: autoCloseAfterMs,
      timerProgressBar: true,
      customClass: {
        container: "vq-update-success-overlay",
        popup: "manual-quote-success-popup",
        confirmButton: "manual-quote-success-popup__home-btn",
      },
    }).then(() => {
      if (options?.redirectToHome !== false) {
        navigate("/");
      }
    });
  };

  /** True after QuotesView request has begun (loading flipped on). Avoids DATANOTFOUND flash before useEffect/makeRequest runs. */
  const sawQuotViewLoadingRef = useRef(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  useLayoutEffect(() => {
    sawQuotViewLoadingRef.current = false;
    setHasLoadedOnce(false);
    if (!id) return;
    const payload = { quotation_id: id };
    quotationView.makeRequest({ payload, url: ApiConstants?.QuotesView, toastStatus: false });
    brandList.makeRequest({ url: ApiConstants?.BrandList, toastStatus: false });
  }, [id, quotationReject?.status, ProductAdd?.status]);

  useEffect(() => {
    const st = location.state as { showAddressUpdatedPopup?: boolean; quoteId?: string } | null;
    if (!st?.showAddressUpdatedPopup || !st.quoteId || String(st.quoteId) !== String(id)) return;
    navigate(location.pathname, { replace: true, state: {} });
    showQuoteUpdatedHomePopup({ autoCloseAfterMs: 5000, quoteId: String(st.quoteId), redirectToHome: false });
  }, [id, location.pathname, location.state, navigate]);

  useEffect(() => {
    const st = location.state as { pendingAnotherProduct?: any; pendingQuantityEdits?: any; pendingDeliveryEdit?: any; pendingDeletedItems?: any[] } | null;
    if (!st?.pendingAnotherProduct && !st?.pendingQuantityEdits && !st?.pendingDeliveryEdit && !st?.pendingDeletedItems) return;
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.pathname, location.state, navigate]);

  useEffect(() => {
    if (quotationView.loading) {
      sawQuotViewLoadingRef.current = true;
    }
  }, [quotationView.loading]);

  useEffect(() => {
    if (!quotationView.loading && quotationView?.status) {
      setHasLoadedOnce(true);
    }
  }, [quotationView.loading, quotationView?.status]);

  const quotationData = quotationView?.data?.data;

  /** Match list/grid display: `res?.new_quantity ?? res?.quantity` */
  const quotationBaselineQty = (row: any) => row?.new_quantity ?? row?.quantity;
  const quoteStatusStr = String(quotationData?.status ?? "");
  const hasAdminLinePricing = useMemo(
    () => quotationHasLineAdminPricing(quotationData),
    [quotationData],
  );
  const hasPriceBreakdownValues = useMemo(
    () => quotationHasPriceBreakdownValues(quotationData),
    [quotationData],
  );
  /** Show Unit / Ext / ETA: Quoted, or Rejected when admin already entered pricing. */
  const isQuotedView =
    quoteStatusStr === "1" || (quoteStatusStr === "3" && hasAdminLinePricing);

  /** N/A unavailable lines for every status (quoting, quoted, rejected, etc.). */
  const quoteQtyDisplay = (row: any) => formatQuotedQtyDisplay(row);

  const formatQuotedMoneyCell = (row: any, kind: "unit" | "extended") => {
    if (isQuoteLineUnavailable(row)) return QUOTE_UNAVAILABLE_DASH;
    const amount =
      kind === "unit" ? Number(row?.per_product_price) : getQuotedLineExtendedAmount(row);
    if (amount == null || !Number.isFinite(amount) || amount <= 0) return QUOTE_UNAVAILABLE_DASH;
    return `${CurrencyIcon(currency)}${getPriceHelper(CurrencyConvertHistory(amount, currency))}`;
  };

  const formatQuotedEtaCell = (row: any) => {
    if (isQuoteLineUnavailable(row)) return QUOTE_UNAVAILABLE_DASH;
    const eta = row?.eta_day;
    if (eta == null || String(eta).trim() === "") return QUOTE_UNAVAILABLE_DASH;
    return String(eta).trim();
  };

  const revertQuotesFromQuotationDetail = () => {
    const rows = quotationView?.data?.data?.quotes_detail;
    if (!Array.isArray(rows)) return;
    setQuotes(
      rows.map((res: any) => ({
        quote_id: res?.id,
        quantity: quotationBaselineQty(res),
        pre_quantity: quotationBaselineQty(res),
      }))
    );
  };

  useEffect(() => {
    setDeliverySectionVisible(false);
    setDeliveryPick(null);
    setDeliveryPickError("");
    setDeliveryNewAddressInline(false);
    setAppliedAddressId("");
    setAppliedAddressLabel("");
    setAppliedShippingId("");
    setNotesViewOpen(false);
    setTableQtyEditingQuoteId(null);
    setTableQtyStepperUsed(false);
    quotationNotes.reset();
    quotationNotesSeen.reset();
    setHasUnseenNotes(false);
  }, [id]);

  const fetchQuotationNotes = useCallback((markSeen = false) => {
    const qid = quotationData?.quotation_id ?? id;
    if (!qid) return;
    quotationNotes.makeRequest({
      payload: { quotation_id: qid, mark_seen: markSeen },
      url: ApiConstants?.QuotesQuotationNotes,
      toastStatus: false,
    });
  }, [quotationData?.quotation_id, id]);

  useEffect(() => {
    if (!quotationView?.status || !quotationData?.quotation_id) return;
    fetchQuotationNotes();
  }, [quotationView?.status, quotationData?.quotation_id, fetchQuotationNotes]);

  useEffect(() => {
    if (!quotationView?.status || !quotationData) return;
    if (quotationData.has_unseen_notes != null) {
      setHasUnseenNotes(Boolean(quotationData.has_unseen_notes));
    }
  }, [quotationView?.status, quotationData?.has_unseen_notes, quotationData?.quotation_id]);

  useEffect(() => {
    if (!quotationNotes?.status) return;
    const payload = quotationNotes?.data?.data;
    if (payload?.unread_notes != null) {
      setHasUnseenNotes(Number(payload.unread_notes) === 1);
    } else if (payload?.has_unseen_notes != null) {
      setHasUnseenNotes(Boolean(payload.has_unseen_notes));
    }
    if (payload?.notes_seen || payload?.unread_notes === 0) {
      setHasUnseenNotes(false);
    }
  }, [quotationNotes?.status, quotationNotes?.data]);

  /* Notes marked read via POST /quotes/quotation-notes with mark_seen: true when opening Notes */

  useEffect(() => {
    if (!deliverySectionVisible) {
      if (deliveryUpdateConfirmed) {
        setDeliveryPickError("");
        setDeliveryNewAddressInline(false);
        return;
      }
      setDeliveryPick(null);
      setDeliveryPickError("");
      setDeliverySelectionTouched(false);
      setDeliveryNewAddressInline(false);
      return;
    }
    if (!Array.isArray(addressListDelivery?.data?.data?.rows) && !addressListDelivery?.loading) {
      addressListDelivery.makeRequest({ url: ApiConstants?.AddressList, toastStatus: false });
    }
    if (!Array.isArray(shippingListDelivery?.data?.data) && !shippingListDelivery?.loading) {
      shippingListDelivery.makeRequest({ url: ApiConstants?.ShippingList, toastStatus: false });
    }
  }, [deliverySectionVisible, deliveryUpdateConfirmed, addressListDelivery?.data?.data?.rows, addressListDelivery?.loading, shippingListDelivery?.data?.data, shippingListDelivery?.loading]);

  useEffect(() => {
    if (!deliverySectionVisible) return;
    const rows = addressListDelivery?.data?.data?.rows;
    if (!Array.isArray(rows)) return;
    if (pendingCreatedAddressId) {
      const created = rows.find((r: any) => String(r.id) === String(pendingCreatedAddressId));
      if (created) {
        setDeliveryPick(created);
        setDeliverySelectionTouched(true);
        setDeliveryUpdateConfirmed(false);
        setQuotesEdit(tableQtyStepperUsed);
        setPendingCreatedAddressId("");
        return;
      }
    }
    if (deliverySelectionTouched && deliveryPick?.id != null) return;
    const cid = appliedAddressId || String(quotationData?.address_id ?? "");
    const found = cid != null && cid !== "" ? rows.find((r: any) => String(r.id) === String(cid)) : null;
    setDeliveryPick(found ?? null);
  }, [deliverySectionVisible, addressListDelivery?.data?.data?.rows, quotationData?.address_id, appliedAddressId, pendingCreatedAddressId, deliverySelectionTouched, deliveryPick?.id, tableQtyStepperUsed]);

  useEffect(() => {
    if (!deliverySectionVisible) return;
    if (deliveryShippingPick) return;
    const qShip = appliedShippingId || quotationData?.shipping_id;
    if (qShip != null && String(qShip).trim() !== "") {
      setDeliveryShippingPick(String(qShip));
      return;
    }
    const rows = Array.isArray(shippingListDelivery?.data?.data) ? shippingListDelivery.data.data : [];
    if (rows.length > 0 && !deliveryShippingPick) {
      const firstRef = rows[0]?.shipping_details?.ref_id ?? rows[0]?.ref_id;
      if (firstRef != null) setDeliveryShippingPick(String(firstRef));
    }
  }, [deliverySectionVisible, quotationData?.shipping_id, shippingListDelivery?.data?.data, deliveryShippingPick, appliedShippingId]);

  useEffect(() => {
    if (quotationData?.address_id != null && !appliedAddressId) {
      setAppliedAddressId(String(quotationData.address_id));
    }
    if (quotationData?.shipping_id != null && !appliedShippingId) {
      setAppliedShippingId(String(quotationData.shipping_id));
    }
    if (!appliedAddressLabel && quotationData) {
      setAppliedAddressLabel(formatQuotationAddress(quotationData));
    }
  }, [quotationData, appliedAddressId, appliedShippingId, appliedAddressLabel]);

  useEffect(() => {
    if (!pendingDeliveryEdit) return;
    const currentQuotationId = quotationData?.quotation_id ?? id;
    if (pendingDeliveryEdit?.quotation_id != null && String(pendingDeliveryEdit.quotation_id) !== String(currentQuotationId)) return;
    setDeliveryPick(pendingDeliveryEdit.deliveryPick ?? null);
    setDeliveryShippingPick(String(pendingDeliveryEdit.deliveryShippingPick ?? ""));
    setDeliverySelectionTouched(Boolean(pendingDeliveryEdit.deliverySelectionTouched));
    setDeliveryUpdateConfirmed(Boolean(pendingDeliveryEdit.deliveryUpdateConfirmed));
    setDeliveryPickError("");
    setDeliveryNewAddressInline(false);
    if (pendingDeliveryEdit.deliveryPick?.id || pendingDeliveryEdit.deliveryShippingPick) {
      setQuotesEdit(true);
    }
    setPendingDeliveryEdit(null);
  }, [pendingDeliveryEdit, quotationData?.quotation_id, id]);

  useEffect(() => {
    if (!addressDeliveryUpdate?.status || !id) return;
    setQuotesEdit(false);
    setDeliverySectionVisible(false);
    setDeliveryUpdateConfirmed(false);
    setDeliveryPickError("");
    setDeliverySelectionTouched(false);
    setPendingDeliveryEdit(null);
    if (deliveryPick?.id != null) {
      setAppliedAddressId(String(deliveryPick.id));
      setAppliedAddressLabel(formatAddressListRow(deliveryPick));
    }
    if (deliveryShippingPick) {
      setAppliedShippingId(String(deliveryShippingPick));
    }
    addressListDelivery.makeRequest({ url: ApiConstants?.AddressList, toastStatus: false });
    shippingListDelivery.makeRequest({ url: ApiConstants?.ShippingList, toastStatus: false });

    const nextQuotationId =
      addressDeliveryUpdate?.data?.data?.quotation_id != null
        ? String(addressDeliveryUpdate.data.data.quotation_id)
        : String(id);
    const createdNewQuote = nextQuotationId !== String(id);

    if (suppressAddressSuccessPopupRef.current) {
      suppressAddressSuccessPopupRef.current = false;
      return;
    }

    if (createdNewQuote) {
      navigate(AppRoutes.Viewquote.replace(":id", nextQuotationId), {
        replace: true,
        state: { showAddressUpdatedPopup: true, quoteId: nextQuotationId },
      });
      return;
    }

    quotationView.makeRequest({
      payload: { quotation_id: id },
      url: ApiConstants?.QuotesView,
      toastStatus: false,
    });
    showQuoteUpdatedHomePopup({ autoCloseAfterMs: 5000, quoteId: nextQuotationId, redirectToHome: false });
  }, [addressDeliveryUpdate?.status]);

  const getTaxValue = (e: any) => {
    if (e?.tax_amount && e?.total_amount) {
      const total = Number(e?.total_shipping_price) + Number(e?.total_product_price) + Number(e?.other_charges);
      const taxValue = (total * e?.tax_amount) / 100;
      return `${taxValue.toFixed(2)}`;
    }
    return "0.00";
  };

  const CloseMessageModal = () => setShowMessage(false);
  const CloseEditModal = () => setEditShow(false);
  const handelReject = () => {
    if (anotherProduct != null && anotherProduct?.quotation_id == id) {
      return toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT);
    }
    Swal.fire({
      title: LanguageConstants?.ARE_YOU_SURE,
      text: LanguageConstants?.REJECT_QUTO,
      icon: "warning",
      confirmButtonColor: "#31CE36",
      cancelButtonColor: "#d33",
      showDenyButton: true,
      denyButtonText: LanguageConstants?.NO,
      confirmButtonText: LanguageConstants?.YES,
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        const payload = { quotation_id: id };
        quotationReject.makeRequest({ payload, url: ApiConstants?.QuotesStatusUpdate, toastStatus: true });
      }
    });
  };

  const handelAddProduct = () => {
    const pendingQuotes =
      anotherProduct?.quotation_id == id && Array.isArray(anotherProduct?.quotes)
        ? anotherProduct.quotes
        : [];
    const pendingDeletedIds = new Set(pendingDeletedItems.map((item: any) => String(item.product_id)));
    const existingQuotePartNumbers = (quotationView?.data?.data?.quotes_detail ?? [])
      .filter((row: any) => row?.id == null || !pendingDeletedIds.has(String(row.id)))
      .map((row: any) => row?.part_number)
      .filter((partNumber: any) => String(partNumber ?? "").trim() !== "");
    const savedQuoteCount = Math.max((quotationView?.data?.data?.quotes_detail?.length ?? 0) - pendingDeletedItems.length, 0);
    navigate("/create-request-quote", {
      state: {
        data: quotationView?.data?.data?.quotation_id,
        quotes_length: savedQuoteCount + pendingQuotes.length,
        existingQuotePartNumbers,
        pendingAnotherProduct: pendingQuotes.length
          ? { quotes: pendingQuotes, quotation_id: quotationView?.data?.data?.quotation_id }
          : undefined,
        pendingQuantityEdits: {
          quotes,
          quotation_id: quotationView?.data?.data?.quotation_id,
        },
        pendingDeliveryEdit:
          deliveryPick?.id || deliveryShippingPick || deliveryUpdateConfirmed
            ? {
                quotation_id: quotationView?.data?.data?.quotation_id,
                deliveryPick,
                deliveryShippingPick,
                deliverySelectionTouched,
                deliveryUpdateConfirmed,
              }
            : undefined,
        pendingDeletedItems,
      },
    });
  };

  useEffect(() => {
    if (quotationView?.status) {
      const array: any = [];
      quotationView?.data?.data?.quotes_detail?.map((res: any) =>
        array.push({
          quote_id: res?.id,
          quantity: quotationBaselineQty(res),
          pre_quantity: quotationBaselineQty(res),
        })
      );
      if (
        pendingQuantityEdits?.quotation_id == quotationView?.data?.data?.quotation_id &&
        Array.isArray(pendingQuantityEdits?.quotes)
      ) {
        setQuotes(pendingQuantityEdits.quotes);
      } else {
        setQuotes(array);
      }
    }
  }, [quotationView?.status, pendingQuantityEdits, quotationView?.data?.data?.quotation_id]);

  const handelDownloadPdf = () => {
    if (!id) return;
    void openQuotationPdfInNewTab(String(id));
  };

  const handleDeliveryAddressApply = () => {
    if (deliveryNewAddressInline) return;
    if (!deliveryPick?.id) {
      setDeliveryPickError(LanguageConstants?.PLEASE_SELECR_DELIVER_ADDRESS ?? "Please select delivery address");
      return;
    }
    setDeliveryPickError("");
    setDeliverySelectionTouched(true);
    setDeliveryUpdateConfirmed(true);
    setDeliveryNewAddressInline(false);
    setDeliverySectionVisible(false);
    setQuotesEdit(true);
  };

  const handelUpdate = () => {
    const p1 =
      LanguageConstants?.VIEW_QUOTE_UPDATE_BODY_P1 ??
      "Changes that have been made require requoting from admin.";
    const p2 =
      LanguageConstants?.VIEW_QUOTE_UPDATE_BODY_P2 ??
      "A request will be sent to admin. They will review the details and will notify you as soon as your quote is ready.";
    const p3 = LanguageConstants?.VIEW_QUOTE_UPDATE_BODY_P3 ?? "Do you wish to continue?";
    const continueText = LanguageConstants?.COUNTINUE ?? "Continue";
    void Swal.fire({
      icon: "warning",
      title: LanguageConstants?.VIEW_QUOTE_UPDATE_TITLE ?? "Update Quote",
      html: `<p class="mb-0">${p1}</p><p class="mb-0 mt-3">${p2}</p><p class="mb-0 mt-3">${p3}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: continueText,
      cancelButtonText: LanguageConstants?.CANCEL ?? "Cancel",
      buttonsStyling: false,
      reverseButtons: true,
      customClass: {
        container: "logout-com-modal-wrap",
        popup: "logout-com-modal",
        title: "logout-com-modal__title",
        closeButton: "logout-com-modal__close",
        htmlContainer: "logout-com-modal__html",
        actions: "logout-com-modal__footer",
        confirmButton: "logout-com-modal__btn logout-com-modal__btn--confirm com-btn",
        cancelButton: "logout-com-modal__btn logout-com-modal__btn--cancel com-btn com-btn-outline",
      },
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
      preConfirm: async () => {
        const confirmBtn = Swal.getConfirmButton();
        const cancelBtn = Swal.getCancelButton();
        if (confirmBtn) {
          confirmBtn.disabled = true;
          confirmBtn.innerHTML = `<span class="vq-deliveryPanel__btnLoading"><span class="vq-deliveryPanel__btnSpinner" aria-hidden="true"></span>Loading...</span>`;
        }
        if (cancelBtn) cancelBtn.disabled = true;

        try {
          const changedQuantityPayload = getChangedQuantityPayload();
          const hasQuantityUpdate = changedQuantityPayload.length > 0;
          const hasProductAddUpdate = hasPendingAddedItems;
          const hasDeleteUpdate = pendingDeletedItems.length > 0;
          const currentQuotationId = String(quotationView?.data?.data?.quotation_id ?? "");
          let nextQuotationId = currentQuotationId;

          const sameQuoteLine = (left: any, right: any) => {
            const fields = [
              "brand_id",
              "part_number",
              "description",
              "serial_number",
              "model_number",
              "sku",
              "is_other_brand",
              "other_brand_name",
            ];
            return fields.every((field) => String(left?.[field] ?? "") === String(right?.[field] ?? ""));
          };

          const resolveDeletePayloads = async (targetQuotationId: string) => {
            if (!hasDeleteUpdate) return [];
            if (targetQuotationId === currentQuotationId) {
              return pendingDeletedItems.map((item: any) => ({
                product_id: item.product_id,
                quotation_id: targetQuotationId,
                s_no: item.s_no,
              }));
            }

            const detailResp = await POSTAPI(ApiConstants?.QuotesView, { quotation_id: targetQuotationId }, false);
            const targetRows = Array.isArray(detailResp?.data?.quotes_detail) ? detailResp.data.quotes_detail : [];
            const usedTargetIds = new Set<string>();
            return pendingDeletedItems.map((item: any) => {
              const match = targetRows.find((row: any) => {
                if (row?.id == null || usedTargetIds.has(String(row.id))) return false;
                return sameQuoteLine(row, item.row);
              });
              if (!match?.id) {
                throw new Error("Unable to map deleted quote item to updated quotation.");
              }
              usedTargetIds.add(String(match.id));
              return {
                product_id: match.id,
                quotation_id: targetQuotationId,
                s_no: item.s_no,
              };
            });
          };

          const resolveQuantityPayloads = async (targetQuotationId: string) => {
            if (!hasQuantityUpdate || targetQuotationId === currentQuotationId) {
              return changedQuantityPayload;
            }

            const detailResp = await POSTAPI(ApiConstants?.QuotesView, { quotation_id: targetQuotationId }, false);
            const targetRows = Array.isArray(detailResp?.data?.quotes_detail) ? detailResp.data.quotes_detail : [];
            const sourceRows = Array.isArray(quotationView?.data?.data?.quotes_detail)
              ? quotationView.data.data.quotes_detail
              : [];
            const usedTargetIds = new Set<string>();

            return changedQuantityPayload.map((item: any) => {
              const sourceRow = sourceRows.find((row: any) => String(row?.id) === String(item.quote_id));
              const match = targetRows.find((row: any) => {
                if (row?.id == null || usedTargetIds.has(String(row.id))) return false;
                return sameQuoteLine(row, sourceRow);
              });
              if (!match?.id) {
                throw new Error("Unable to map quantity change to updated quotation.");
              }
              usedTargetIds.add(String(match.id));
              return {
                ...item,
                quote_id: match.id,
              };
            });
          };

          if (deliveryUpdateConfirmed && hasDeliverySelectionChanges) {
            if (!deliveryPick?.id) {
              throw new Error(LanguageConstants?.PLEASE_SELECR_DELIVER_ADDRESS ?? "Please select delivery address");
            }
            suppressAddressSuccessPopupRef.current = hasQuantityUpdate || hasProductAddUpdate || hasDeleteUpdate;
            const addressResp = await addressDeliveryUpdate.makeRequest({
              payload: {
                address_id: deliveryPick.id,
                quotation_id: currentQuotationId,
                shipping_id: deliveryShippingPick ? Number(deliveryShippingPick) : undefined,
              },
              url: ApiConstants?.QuotesAddressUpdate,
              toastStatus: !(hasQuantityUpdate || hasProductAddUpdate || hasDeleteUpdate),
            });
            nextQuotationId =
              addressResp?.data?.quotation_id != null
                ? String(addressResp.data.quotation_id)
                : currentQuotationId;
            combinedUpdateQuoteIdRef.current = nextQuotationId || null;
          }

          if (hasProductAddUpdate) {
            if (!hasQuantityUpdate && !hasDeleteUpdate && !(deliveryUpdateConfirmed && hasDeliverySelectionChanges)) {
              productAddUpdateOnlyRef.current = true;
            }
            await ProductAdd.makeRequest({
              payload: { ...anotherProduct, quotation_id: nextQuotationId },
              url: ApiConstants?.QuotesProductAdd,
              toastStatus: false,
            });
          }

          if (hasDeleteUpdate) {
            const deletePayloads = await resolveDeletePayloads(nextQuotationId);
            for (const deletePayload of deletePayloads) {
              const deleteResp = await POSTAPI(ApiConstants?.QuotesProductdelete, deletePayload, false);
              if (deleteResp?.status !== true) {
                throw new Error(deleteResp?.message || "Unable to delete quote item.");
              }
            }
          }

          if (hasQuantityUpdate) {
            const quantityPayload = await resolveQuantityPayloads(nextQuotationId);
            await QuotationUpdate.makeRequest({
              payload: {
                quotes: quantityPayload,
                quotation_id: nextQuotationId,
                address_id: deliveryPick?.id ?? quotationView?.data?.data?.address_id,
              },
              url: ApiConstants?.QuotesUpdate,
              toastStatus: true,
            });
          } else if (hasDeleteUpdate || ((deliveryUpdateConfirmed && hasDeliverySelectionChanges) && hasProductAddUpdate)) {
            setPendingDeletedItems([]);
            setQuotesEdit(false);
            setTableQtyEditingQuoteId(null);
            setTableQtyStepperUsed(false);
            setDeliveryUpdateConfirmed(false);
            const payload = { sender_type: "1", receiver_id: "1" };
            socket.emit("admin_count", payload, async () => {});
            window.setTimeout(() => {
              showQuoteUpdatedHomePopup(nextQuotationId ? { quoteId: nextQuotationId } : undefined);
            }, 0);
          }
          return true;
        } catch {
          suppressAddressSuccessPopupRef.current = false;
          combinedUpdateQuoteIdRef.current = null;
          productAddUpdateOnlyRef.current = false;
          if (confirmBtn) {
            confirmBtn.disabled = false;
            confirmBtn.textContent = continueText;
          }
          if (cancelBtn) cancelBtn.disabled = false;
          Swal.showValidationMessage("Unable to update quote.");
          return false;
        }
      },
    });
  };

  const getTableLineQty = (res: any, kind: string) => {
    if (kind === "api" && res?.id != null) {
      const hit = quotes.find((q: any) => String(q.quote_id) === String(res.id));
      if (hit?.quantity != null && String(hit.quantity).trim() !== "") {
        const n = parseInt(String(hit.quantity), 10);
        if (Number.isFinite(n) && n >= 1) return Math.min(999999, n);
      }
    }
    const raw = res?.new_quantity ?? res?.quantity;
    const n = parseInt(String(raw ?? "1"), 10);
    return Number.isFinite(n) && n >= 1 ? Math.min(999999, n) : 1;
  };

  const getPendingQtyEditKey = (res: any) => `pending-${res?.__pendingAnotherProductIndex ?? ""}`;

  const pendingDeletedQuoteIds = useMemo(
    () => new Set(pendingDeletedItems.map((item: any) => String(item.product_id))),
    [pendingDeletedItems],
  );

  const hasPendingQuantityChanges = useCallback(
    (candidateQuotes: any[] = quotes) => {
      const rows = quotationView?.data?.data?.quotes_detail;
      if (!Array.isArray(rows)) return false;
      return rows.some((row: any) => {
        if (row?.id == null) return false;
        if (pendingDeletedQuoteIds.has(String(row.id))) return false;
        const hit = candidateQuotes.find((q: any) => String(q.quote_id) === String(row.id));
        if (hit?.quantity == null || String(hit.quantity).trim() === "") return false;
        return String(hit.quantity) !== String(quotationBaselineQty(row));
      });
    },
    [quotes, quotationView?.data?.data?.quotes_detail, pendingDeletedQuoteIds],
  );

  const hasQuantityChanges = hasPendingQuantityChanges();
  const hasDeliverySelectionChanges =
    (deliveryPick?.id != null &&
      String(deliveryPick.id) !== String(appliedAddressId || (quotationData?.address_id ?? ""))) ||
    (String(deliveryShippingPick ?? "").trim() !== "" &&
      String(deliveryShippingPick) !== String(appliedShippingId || (quotationData?.shipping_id ?? "")));
  const hasPendingAddedItems =
    anotherProduct?.quotation_id == id &&
    Array.isArray(anotherProduct?.quotes) &&
    anotherProduct.quotes.length > 0;
  const hasPendingDeletedItems = pendingDeletedItems.length > 0;

  const getChangedQuantityPayload = useCallback(() => {
    const rows = quotationView?.data?.data?.quotes_detail;
    if (!Array.isArray(rows)) return [];
    return rows.reduce((acc: any[], row: any, index: number) => {
      if (row?.id == null) return acc;
      if (pendingDeletedQuoteIds.has(String(row.id))) return acc;
      const hit = quotes.find((q: any) => String(q.quote_id) === String(row.id));
      if (hit?.quantity == null || String(hit.quantity).trim() === "") return acc;
      const baseline = quotationBaselineQty(row);
      if (String(hit.quantity) === String(baseline)) return acc;
      acc.push({
        ...hit,
        quote_id: row.id,
        quantity: String(hit.quantity),
        pre_quantity: baseline,
        s_no: hit.s_no ?? String(index + 1),
      });
      return acc;
    }, []);
  }, [quotes, quotationView?.data?.data?.quotes_detail, pendingDeletedQuoteIds]);

  useEffect(() => {
    setTableQtyStepperUsed(hasQuantityChanges);
    setQuotesEdit(hasQuantityChanges || hasPendingAddedItems || hasPendingDeletedItems || (deliveryUpdateConfirmed && hasDeliverySelectionChanges));
  }, [hasQuantityChanges, hasPendingAddedItems, hasPendingDeletedItems, deliveryUpdateConfirmed, hasDeliverySelectionChanges]);

  const setTableLineQty = (res: any, kind: string, displayNo: number, nextQty: number) => {
    const str = String(nextQty);
    // Max 6 digits (1–999999); keep in sync with QuotationTableQtyStepper.
    if (!/^[1-9]\d{0,5}$/.test(str) || nextQty < 1 || nextQty > 999999) return;
    if (kind === "pending") {
      const pendingIndex = Number(res?.__pendingAnotherProductIndex);
      const pendingKey = getPendingQtyEditKey(res);
      setPendingQtyChangedKeys((prev) => (prev.includes(pendingKey) ? prev : [...prev, pendingKey]));
      setPendingAnotherProduct((prev: any) => {
        if (!prev || !Array.isArray(prev.quotes) || !Number.isFinite(pendingIndex)) return prev;
        return {
          ...prev,
          quotes: prev.quotes.map((quote: any, index: number) =>
            index === pendingIndex ? { ...quote, quantity: str, new_quantity: str } : quote
          ),
        };
      });
      return;
    }
    if (kind !== "api" || res?.id == null) return;
    setQuotes((prev: any[]) => {
      const idx = prev.findIndex((q: any) => String(q.quote_id) === String(res.id));
      if (idx === -1) {
        return [
          ...prev,
          {
            quote_id: res.id,
            quantity: str,
            s_no: String(displayNo),
            pre_quantity: quotationBaselineQty(res),
          },
        ];
      }
      return prev.map((q: any) =>
        String(q.quote_id) === String(res.id) ? { ...q, quantity: str, s_no: String(displayNo) } : q
      );
    });
  };

  const isTableLineQtyChanged = (res: any, kind: string) => {
    if (kind === "pending") {
      return pendingQtyChangedKeys.includes(getPendingQtyEditKey(res));
    }
    if (kind !== "api" || res?.id == null) return false;
    const hit = quotes.find((q: any) => String(q.quote_id) === String(res.id));
    if (hit?.quantity == null || String(hit.quantity).trim() === "") return false;
    return String(hit.quantity) !== String(quotationBaselineQty(res));
  };

  const handleRowQtyEdit = (res: any, kind: string, displayNo: number, editDis: boolean) => {
    if (editDis) {
      toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT);
      return;
    }
    if (isQuoteLineUnavailable(res)) {
      return;
    }
    setSendData(res);
    setS_no(String(displayNo));
    if (kind === "api") {
      setTableQtyEditingQuoteId(res?.id);
    } else {
      setTableQtyEditingQuoteId(getPendingQtyEditKey(res));
    }
  };

  const renderQtyControl = (res: any, kind: string, displayNo: number, editDis: boolean) => {
    const pendingEditOpen =
      kind === "pending" &&
      tableQtyEditingQuoteId != null &&
      String(tableQtyEditingQuoteId) === getPendingQtyEditKey(res);
    if (
      (kind === "api" || kind === "pending") &&
      canEditRow &&
      !editDis &&
      tableQtyEditingQuoteId != null &&
      ((kind === "api" && String(tableQtyEditingQuoteId) === String(res?.id)) || pendingEditOpen)
    ) {
      return (
        <QuotationTableQtyStepper
          value={getTableLineQty(res, kind)}
          disabled={editDis}
          changed={isTableLineQtyChanged(res, kind)}
          onChange={(n) => setTableLineQty(res, kind, displayNo, n)}
        />
      );
    }
    if (isTableLineQtyChanged(res, kind)) {
      return (
        <span className="vq-qtyStep__val vq-qtyStep__val--changed">{getTableLineQty(res, kind)}</span>
      );
    }
    return quoteQtyDisplay(res);
  };

  const performTableQtyCancel = () => {
    const rows = quotationView?.data?.data?.quotes_detail;
    if (!Array.isArray(rows)) {
      setTableQtyEditingQuoteId(null);
      setTableQtyStepperUsed(false);
      setQuotesEdit(deliveryUpdateConfirmed && hasDeliverySelectionChanges);
      return;
    }
    revertQuotesFromQuotationDetail();
    setTableQtyEditingQuoteId(null);
    setTableQtyStepperUsed(false);
    setPendingQuantityEdits(null);
    setQuotesEdit(deliveryUpdateConfirmed && hasDeliverySelectionChanges);
  };

  const performDeliveryAddressCancel = () => {
    const rows = addressListDelivery?.data?.data?.rows;
    const cid = appliedAddressId || String(quotationData?.address_id ?? "");
    const found = Array.isArray(rows) && cid !== "" ? rows.find((r: any) => String(r.id) === String(cid)) : null;
    setDeliveryPick(found ?? null);
    setDeliveryShippingPick(appliedShippingId || String(quotationData?.shipping_id ?? ""));
    setDeliveryPickError("");
    setDeliverySelectionTouched(false);
    setDeliveryUpdateConfirmed(false);
    setDeliveryNewAddressInline(false);
    setDeliverySectionVisible(false);
    setPendingCreatedAddressId("");
    setPendingDeliveryEdit(null);
    setQuotesEdit(tableQtyStepperUsed);
  };

  const performPendingAddedItemsCancel = () => {
    setPendingAnotherProduct(null);
    setPendingQtyChangedKeys([]);
    setPendingDeletedItems([]);
    setQuotesEdit(hasQuantityChanges || (deliveryUpdateConfirmed && hasDeliverySelectionChanges));
  };

  const performAllQuoteEditCancel = () => {
    revertQuotesFromQuotationDetail();
    setTableQtyEditingQuoteId(null);
    setTableQtyStepperUsed(false);
    setPendingQuantityEdits(null);
    setPendingAnotherProduct(null);
    setPendingQtyChangedKeys([]);
    setPendingDeletedItems([]);
    performDeliveryAddressCancel();
    setQuotesEdit(false);
  };

  const promptCancelEditDiscard = (onConfirmDiscard: () => void) => {
    const body1 =
      LanguageConstants?.VIEW_QUOTE_CANCEL_EDIT_BODY_1 ?? "No changes will be saved if you cancel.";
    const body2 = LanguageConstants?.VIEW_QUOTE_CANCEL_EDIT_BODY_2 ?? "Do you want to continue?";

    Swal.fire({
      icon: "warning",
      title: LanguageConstants?.VIEW_QUOTE_CANCEL_EDIT_TITLE ?? "Cancel Edit",
      html: `<p class="mb-0">${body1}</p><p class="mb-0 mt-3">${body2}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: LanguageConstants?.NO ?? "No",
      confirmButtonText: LanguageConstants?.YES ?? "Yes",
      buttonsStyling: false,
      reverseButtons: true,
      customClass: {
        container: "logout-com-modal-wrap",
        popup: "logout-com-modal",
        title: "logout-com-modal__title",
        closeButton: "logout-com-modal__close",
        htmlContainer: "logout-com-modal__html",
        actions: "logout-com-modal__footer",
        confirmButton: "logout-com-modal__btn logout-com-modal__btn--confirm com-btn",
        cancelButton: "logout-com-modal__btn logout-com-modal__btn--cancel com-btn com-btn-outline",
      },
    }).then((result: { isConfirmed?: boolean }) => {
      if (result.isConfirmed) onConfirmDiscard();
    });
  };

  const handleTableQtyCancel = () => {
    promptCancelEditDiscard(() => performTableQtyCancel());
  };

  const handleDeliveryAddressCancel = () => {
    promptCancelEditDiscard(() => performDeliveryAddressCancel());
  };

  const handlePendingAddedItemsCancel = () => {
    promptCancelEditDiscard(() => performPendingAddedItemsCancel());
  };

  const handleAllQuoteEditCancel = () => {
    promptCancelEditDiscard(() => performAllQuoteEditCancel());
  };

  const confirmCloseEditQuantityModal = () => {
    promptCancelEditDiscard(() => {
      revertQuotesFromQuotationDetail();
      setQuotesEdit(false);
      setEditShow(false);
    });
  };

  useEffect(() => {
    if (QuotationUpdate?.status) {
      const popupQuoteId = combinedUpdateQuoteIdRef.current;
      combinedUpdateQuoteIdRef.current = null;
      setQuotesEdit(false);
      setTableQtyEditingQuoteId(null);
      setTableQtyStepperUsed(false);
      setDeliveryUpdateConfirmed(false);
      setPendingDeletedItems([]);
      setPendingQuantityEdits(null);
      setPendingDeliveryEdit(null);
      const payload = { sender_type: "1", receiver_id: "1" };
      socket.emit("admin_count", payload, async () => {});
      showQuoteUpdatedHomePopup(popupQuoteId ? { quoteId: popupQuoteId } : undefined);
    }
  }, [QuotationUpdate?.status]);

  const getBrandName = (bid: any) => {
    const name = brandList?.data?.data?.filter((res: any) => res?.id == bid);
    return name?.length > 0 ? name[0]?.brands_details?.name : "N/A";
  };

  const getBrandForRow = (res: any, isPending: boolean) => {
    if (isPending) {
      return res?.is_other_brand == "1" ? res?.other_brand_name : getBrandName(res?.brand_id);
    }
    return res?.is_other_brand == "1" ? res?.other_brand_name : res?.brand_detail?.name;
  };

  const buildProductTitle = (res: any, brand: string) => {
    const name = String(brand ?? "").trim();
    return name || res?.part_number || "—";
  };

  const handleCheckout = () => {
    if (approveNavigating) return;
    if (anotherProduct != null && anotherProduct?.quotation_id == id) {
      return toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT);
    }
    if (!id) return;
    setApproveNavigating(true);
    navigate(AppRoutes.QuotationCheckout.replace(":id", String(id)));
  };

  useEffect(() => {
    if (ProductAdd?.status) {
      setPendingAnotherProduct(null);
      setPendingQtyChangedKeys([]);
      setPendingQuantityEdits(null);
      setPendingDeliveryEdit(null);
      const payload = { sender_type: "1", receiver_id: "1" };
      socket.emit("admin_count", payload, async () => {});
      if (productAddUpdateOnlyRef.current) {
        productAddUpdateOnlyRef.current = false;
        setQuotesEdit(false);
        setDeliveryUpdateConfirmed(false);
        showQuoteUpdatedHomePopup(combinedUpdateQuoteIdRef.current ? { quoteId: combinedUpdateQuoteIdRef.current } : undefined);
        combinedUpdateQuoteIdRef.current = null;
      }
    }
  }, [ProductAdd.status]);

  const lineRows: LineRow[] = useMemo(() => {
    const api = quotationData?.quotes_detail ?? [];
    const pending =
      anotherProduct?.quotation_id == id && Array.isArray(anotherProduct?.quotes) ? anotherProduct.quotes : [];
    const out: LineRow[] = [];
    api
      .filter((res: any) => !pendingDeletedQuoteIds.has(String(res?.id)))
      .forEach((res: any, i: number) => out.push({ kind: "api", res, displayNo: i + 1 }));
    const visibleApiCount = out.length;
    pending.forEach((res: any, i: number) =>
      out.push({
        kind: "pending",
        res: { ...res, __isPendingAnotherProduct: true, __pendingAnotherProductIndex: i },
        displayNo: visibleApiCount + i + 1,
      })
    );
    return out;
  }, [quotationData?.quotes_detail, anotherProduct, id, pendingDeletedQuoteIds]);

  const confirmLocalProductDelete = useCallback(() => {
    if ((lineRows?.length ?? 0) <= 1) {
      toast.error("You cannot delete this product because it is the last one in this quotation.");
      return;
    }
    const row: any = sendData;
    if (row?.id == null) {
      setProductDelete(false);
      return;
    }
    setPendingDeletedItems((prev: any[]) => {
      if (prev.some((item: any) => String(item.product_id) === String(row.id))) return prev;
      return [
        ...prev,
        {
          product_id: row.id,
          quotation_id: row.quotation_id ?? quotationView?.data?.data?.quotation_id,
          s_no,
          row,
        },
      ];
    });
    setProductDelete(false);
    setTableQtyEditingQuoteId(null);
    setQuotesEdit(true);
  }, [lineRows, sendData, quotationView?.data?.data?.quotation_id, s_no]);

  const itemSearchLc = itemSearch.trim().toLowerCase();

  const filteredRows = useMemo(() => {
    if (!itemSearchLc) return lineRows;
    return lineRows.filter((row) => {
      const brand = getBrandForRow(row.res, row.kind === "pending") || "";
      return quoteRowSearchBlob(row.res, brand).includes(itemSearchLc);
    });
  }, [lineRows, itemSearchLc, brandList?.data]);

  const isItemSearchActive = itemSearch.length > 0;

  const totalItemCount = lineRows.length;

  const adminNoteItems = useMemo(() => {
    if (!quotationNotes?.status) return [] as any[];
    const items = quotationNotes?.data?.data?.items;
    return Array.isArray(items) ? items : [];
  }, [quotationNotes?.status, quotationNotes?.data]);

  const notesByQuoteId = useMemo(() => {
    const m = new Map<string, string>();
    for (const it of adminNoteItems) {
      const note = it?.notes != null ? String(it.notes).trim() : "";
      if (!note || it?.quote_id == null) continue;
      m.set(String(it.quote_id), note);
    }
    return m;
  }, [adminNoteItems]);

  const hasAdminNotes = notesByQuoteId.size > 0;
  const notesApiSettled = Boolean(quotationNotes?.status) || Boolean(quotationNotes?.error);
  const notesBtnDisabled =
    quotationNotes?.loading || !notesApiSettled || !hasAdminNotes;
  const notesBtnInactiveOnScreen = notesViewOpen;
  const isNotesBtnDisabled = notesBtnDisabled || notesBtnInactiveOnScreen;
  const notesBtnAttention = hasAdminNotes && hasUnseenNotes && !isNotesBtnDisabled;

  const closeNotesView = useCallback(() => {
    setNotesViewOpen(false);
    fetchQuotationNotes();
  }, [fetchQuotationNotes]);

  const openNotesView = useCallback(() => {
    fetchQuotationNotes(true);
    setDeliverySectionVisible(false);
    setDeliveryPick(null);
    setDeliveryPickError("");
    setDeliverySelectionTouched(false);
    setDeliveryNewAddressInline(false);
    setNotesViewOpen(true);
  }, [fetchQuotationNotes]);

  const blockingMutation =
    quotationReject?.loading ||
    ProductAdd?.loading;
  const addressRowsReady = Array.isArray(addressListDelivery?.data?.data?.rows);
  const shippingRowsReady = Array.isArray(shippingListDelivery?.data?.data);
  const addressRows = addressRowsReady ? addressListDelivery.data.data.rows : [];
  const shippingRowsRaw = shippingRowsReady ? shippingListDelivery.data.data : [];
  // Render delivery panel content in one pass (no part-by-part flash).
  const deliveryPanelLoading = Boolean(
    (deliveryPanelOpening || deliverySectionVisible) &&
      (addressListDelivery?.loading || shippingListDelivery?.loading || !addressRowsReady || !shippingRowsReady)
  );
  // Keep spinner local to dropdown chevron while panel data is bootstrapping.
  const addressDropdownLoading = deliveryPanelLoading;
  useEffect(() => {
    if (!deliveryPanelOpening || !addressRowsReady || !shippingRowsReady) return;
    setDeliveryPanelOpening(false);
    setDeliverySectionVisible(true);
  }, [deliveryPanelOpening, addressRowsReady, shippingRowsReady]);

  const handleDeliverySectionToggle = () => {
    if (deliverySectionVisible) {
      setDeliveryPanelOpening(false);
      setDeliverySectionVisible(false);
      return;
    }
    if (addressRowsReady && shippingRowsReady) {
      setDeliverySectionVisible(true);
      return;
    }
    setDeliveryPanelOpening(true);
    if (!addressRowsReady && !addressListDelivery?.loading) {
      addressListDelivery.makeRequest({ url: ApiConstants?.AddressList, toastStatus: false });
    }
    if (!shippingRowsReady && !shippingListDelivery?.loading) {
      shippingListDelivery.makeRequest({ url: ApiConstants?.ShippingList, toastStatus: false });
    }
  };
  const shippingRows = useMemo(() => {
    return buildSortedShippingDisplayRows(shippingRowsRaw).map(({ refId, label }) => ({
      refId,
      name: label,
    }));
  }, [shippingRowsRaw]);

  const quotationReady = Boolean(quotationView?.status && quotationData);
  const quotationFetchSettled =
    Boolean(id) && !quotationView.loading && sawQuotViewLoadingRef.current;
  const showInitialPageLoader =
    Boolean(id) &&
    !hasLoadedOnce &&
    (quotationView.loading || (!quotationView.status && quotationView.error == null));

  const longDate = formatDisplayLongDate(
    quotationData?.created_at,
    getDate(quotationData?.created_at),
  );
  const savedDeliveryAddressId = String(appliedAddressId || (quotationData?.address_id ?? ""));
  const hasStagedAddressChange = Boolean(
    deliveryPick?.id != null && String(deliveryPick.id) !== savedDeliveryAddressId,
  );
  const addressAttentionState = hasStagedAddressChange;

  const canEditRow = quotationData?.status == "1" || quotationData?.status == "0";
  const anotherBlocks = false;

  const onDeleteQuotationLine = useCallback(
    (res: any, displayNo: number) => {
      if (res?.__isPendingAnotherProduct) {
        if (totalItemCount <= 1) {
          toast.error("You cannot delete this product because it is the last one in this quotation.");
          return;
        }
        const pendingIndex = Number(res.__pendingAnotherProductIndex);
        setPendingAnotherProduct((prev: any) => {
          if (!prev || !Array.isArray(prev.quotes)) return prev;
          const nextQuotes = prev.quotes.filter((_: any, index: number) => index !== pendingIndex);
          return nextQuotes.length > 0 ? { ...prev, quotes: nextQuotes } : null;
        });
        setQuotesEdit(hasQuantityChanges || hasPendingDeletedItems || (deliveryUpdateConfirmed && hasDeliverySelectionChanges));
        return;
      }
      setProductDelete(!productdelete);
      setSendData(res);
      setS_no(String(displayNo));
    },
    [
      productdelete,
      totalItemCount,
      hasQuantityChanges,
      hasPendingDeletedItems,
      deliveryUpdateConfirmed,
      hasDeliverySelectionChanges,
    ],
  );

  const quotationSearchItemCards = useMemo(
    () =>
      renderQuotationItemCards({
        rows: filteredRows,
        getBrandForRow,
        buildProductTitle,
        canEditRow: Boolean(canEditRow),
        anotherBlocks,
        tableQtyEditingQuoteId,
        isQuotedView,
        renderQtyControl,
        formatQuotedMoneyCell,
        formatQuotedEtaCell,
        handleRowQtyEdit,
        onDeleteLine: onDeleteQuotationLine,
      }),
    [
      filteredRows,
      canEditRow,
      anotherBlocks,
      tableQtyEditingQuoteId,
      isQuotedView,
      onDeleteQuotationLine,
      quotes,
    ],
  );
  const addr = quotationData?.address_detail;

  const numBk = (v: unknown) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const otherChargesLines = useMemo(
    () => parseOtherChargesLines(quotationData?.charges_reason),
    [quotationData?.charges_reason],
  );
  const otherChargesTotal = numBk(quotationData?.other_charges);
  const hasOtherChargesDetail =
    otherChargesLines.length > 0 || otherChargesTotal > 0;
  const totalProductPrice = numBk(quotationData?.total_product_price);
  /** Quoted: any pending customer edit invalidates current priced quote until Update. */
  const hasPendingCustomerQuoteEdits =
    hasQuantityChanges ||
    hasPendingAddedItems ||
    hasPendingDeletedItems ||
    hasDeliverySelectionChanges;
  const canShowApproveCta =
    String(quotationData?.status ?? "") === "1" &&
    totalProductPrice > 0 &&
    !hasPendingCustomerQuoteEdits;

  /** Quoted / approved / rejected: shared price breakdown. Only quoted keeps the approve CTA. */
  const renderQuotedApproveAndBreakdown = (placement: "grid" | "list") => {
    const quoteStatus = String(quotationData?.status ?? "");
    const eligibleStatus =
      quoteStatus === "1" || quoteStatus === "2" || quoteStatus === "3";
    const showPriceBreakdown =
      eligibleStatus &&
      hasPriceBreakdownValues &&
      !(quoteStatus === "1" && hasPendingCustomerQuoteEdits);
    const showApproveCta = canShowApproveCta;
    if (!showPriceBreakdown) return null;

    const breakdown = (
      <div className={`vq__priceBreakdown${placement === "list" ? " vq__priceBreakdown--list" : ""}`}>
        <div className="vq__priceBreakdown__head">
          <h3 className="vq__priceBreakdown__title">{LanguageConstants?.PRICE_BRACKDOWN ?? "Price Breakdown"}</h3>
          <label className="vq__priceBreakdown__toggle">
            <span className="vq__priceBreakdown__switch">
              <input
                type="checkbox"
                checked={currency === "EUR"}
                onChange={(e) => setCurrency(e.target.checked ? "EUR" : "USD")}
                aria-label={LanguageConstants?.CONVERTINPISO}
              />
              <span className="vq__priceBreakdown__switchTrack" aria-hidden />
            </span>
            <span className="vq__priceBreakdown__toggleText">{LanguageConstants?.CONVERTINPISO}</span>
          </label>
        </div>

        <div className="vq__priceBreakdown__rows">
          <div className="vq__priceBreakdown__row">
            <span>{LanguageConstants?.TOTAL_PRODUCT_PRICE ?? LanguageConstants?.TOTALPRODUCTAMOUNT}</span>
            <span className="vq__priceBreakdown__val">
              {CurrencyIcon(currency)}
              {getPriceHelper(CurrencyConvertHistory(numBk(quotationData?.total_product_price), currency))}
            </span>
          </div>
          <div className="vq__priceBreakdown__row">
            <span>{LanguageConstants?.SHIPPINGPRICE ?? LanguageConstants?.TOTALSHIIPNGAMOUNT}</span>
            <span className="vq__priceBreakdown__val">
              {CurrencyIcon(currency)}
              {getPriceHelper(CurrencyConvertHistory(numBk(quotationData?.total_shipping_price), currency))}
            </span>
          </div>
          <div className="vq__priceBreakdown__row">
            <span className="vq__priceBreakdown__rowLabel">
              {LanguageConstants?.OTHER} {LanguageConstants?.CHARGES}
              <button
                type="button"
                className={`vq__priceBreakdown__info${
                  hasOtherChargesDetail ? "" : " vq__priceBreakdown__info--disabled"
                }`}
                disabled={!hasOtherChargesDetail}
                aria-disabled={!hasOtherChargesDetail}
                title={
                  hasOtherChargesDetail
                    ? LanguageConstants?.VIEW_QUOTE_OTHER_CHARGES_BTN ??
                      "View other charges breakdown"
                    : LanguageConstants?.VIEW_QUOTE_OTHER_CHARGES_NONE ??
                      "No other charges details"
                }
                aria-label={LanguageConstants?.Charges_reason ?? "Other charges details"}
                onClick={() => {
                  if (hasOtherChargesDetail) setOtherChargesModalOpen(true);
                }}
              >
                <i className="icon-info"></i>
              </button>
            </span>
            <span className="vq__priceBreakdown__val">
              {CurrencyIcon(currency)}
              {getPriceHelper(CurrencyConvertHistory(numBk(quotationData?.other_charges), currency))}
            </span>
          </div>
          <div className="vq__priceBreakdown__row">
            <span>{LanguageConstants?.TOTALTAX}</span>
            <span className="vq__priceBreakdown__val">
              {CurrencyIcon(currency)}
              {getPriceHelper(CurrencyConvertHistory(getTaxValue(quotationData), currency))}
            </span>
          </div>
        </div>

        <div className="vq__priceBreakdown__divider" />

        <div className="vq__priceBreakdown__grand">
          <div className="vq__priceBreakdown__grandLabel">{LanguageConstants?.GRANDTOTAL}</div>
          <div className="vq__priceBreakdown__grandRight">
            <p className="vq__priceBreakdown__note">
              {currency === "EUR"
                ? LanguageConstants?.VIEW_QUOTE_FOLLOW_EUR ?? "Following price is in EUR"
                : LanguageConstants?.PRIZEMESSAGE}
            </p>
            <div className="vq__priceBreakdown__grandAmt">
              {CurrencyIcon(currency)}
              {getPriceHelper(CurrencyConvertHistory(numBk(quotationData?.total_amount), currency))}
            </div>
          </div>
        </div>
      </div>
    );

    if (placement === "grid") {
      return breakdown;
    }

    if (!showApproveCta) {
      return breakdown;
    }

    return (
      <div className="vq__listQuotedBlock">
        {breakdown}
        <div className="vq__listQuotedBlock__cta">
          {/* <button type="button" className="vq__rejectPill--quoted" onClick={() => handelReject()}>
            {LanguageConstants?.Reject}
          </button> */}
          <button
            type="button"
            className="vq__approvePill--listUnderTable manual-quote-btn com-btn rounded-pill"
            onClick={() => handleCheckout()}
            disabled={approveNavigating}
            aria-busy={approveNavigating}
          >
            {LanguageConstants?.Approve}
          </button>
        </div>
      </div>
    );
  };

  const renderQuotedGridCta = () => {
    if (!canShowApproveCta) return null;
    return (
      <div className="vq__quotedCta vq__quotedCta--grid">
        <div className="vq__quotedCtaRow">
          {/* <button type="button" className="vq__rejectPill--quoted" onClick={() => handelReject()}>
            {LanguageConstants?.Reject}
          </button> */}
          <button
            type="button"
            className="vq__approvePill--grid manual-quote-btn com-btn rounded-pill"
            onClick={() => handleCheckout()}
            disabled={approveNavigating}
            aria-busy={approveNavigating}
          >
            {LanguageConstants?.Approve}
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      {blockingMutation ? <FrontLoader /> : null}
      <PageLoadingShell
        loading={showInitialPageLoader || approveNavigating}
        skeleton={<ListPageSkeleton />}
        className="head-space"
      >
        <div className="inner-content">
          <div className="vq">
            <div className="vq__shell">
              {/* <div className="vq__backRow">
                <button type="button" className="vq__backBtn" onClick={() => navigate("/my-quotation")}>
                  <i className="icon-chev-right" style={{ transform: "rotate(180deg)", display: "inline-block" }} />
                  {LanguageConstants?.BACK ?? "Back"}
                </button>
              </div> */}

              {quotationView?.status && quotationData ? (
                <div
                  className={`vq__layout${
                    notesViewOpen
                      ? " vq__layout--notes"
                      : viewMode === "grid"
                        ? " vq__layout--grid"
                        : " vq__layout--list"
                  }`}
                >
                  <aside className="vq__leftCol">
                    <div className="vq__subCard vq__subCard--quote">
                      <div className="d-flex flex-column-reverse flex-sm-row justify-content-between gap-3">
                      <div className="vq__quoteInfo">
                          <h1 className="vq__title vq__title--quote fs-16 fw-medium">
                            {LanguageConstants?.VIEW_QUOTE_DETAILS ?? "Quote Details"}: {quotationData?.quotation_id}
                          </h1>
                          <div className="vq__meta vq__meta--quote">
                            <span className="fs-16">
                              {LanguageConstants?.VIEW_QUOTE_DATE_LABEL ?? "Date"}:{" "}
                              <span className="vq__metaValue">{longDate}</span>
                            </span>
                            <span className="fs-16">
                              {LanguageConstants?.VIEW_QUOTE_ITEMS_COUNT ?? "Items"} {totalItemCount}
                            </span>
                          </div>
                        </div>
                        <div className="vq__quoteHeroBadge">
                          <QuotationStatusBadge status={quotationData?.status} />
                        </div>
                      </div>
                      <div className="d-flex gap-3 flex-wrap justify-content-between">
                        <div className="vq__quoteHeroNotes">
                          <button
                            type="button"
                            className={`vq__notesBtn vq__notesBtn--chip${
                              notesBtnInactiveOnScreen
                                ? " vq__notesBtn--currentView"
                                : notesBtnDisabled
                                  ? " vq__notesBtn--quoted"
                                  : notesBtnAttention
                                    ? " vq__notesBtn--quotedAttention"
                                    : " vq__notesBtn--quotedSeen"
                            }`}
                            disabled={isNotesBtnDisabled}
                            aria-disabled={isNotesBtnDisabled}
                            aria-pressed={notesViewOpen}
                            title={
                              notesBtnInactiveOnScreen
                                ? LanguageConstants?.VIEW_QUOTE_NOTES ?? "Notes"
                                : notesBtnDisabled
                                  ? LanguageConstants?.VIEW_QUOTE_NOTES_EMPTY ??
                                    "No notes for this quotation."
                                  : LanguageConstants?.VIEW_QUOTE_NOTES ?? "Notes"
                            }
                            onClick={() => {
                              if (isNotesBtnDisabled) return;
                              openNotesView();
                            }}
                          >
                            {LanguageConstants?.VIEW_QUOTE_NOTES ?? "Notes"}
                            <img
                              src={
                                notesBtnAttention
                                  ? exclamationYellowIcon
                                  : exclamationIcon
                              }
                              alt=""
                            />
                          </button>
                        </div>
                        
                      </div>

                      <div className="vq__quoteAddressRow">
                        <div className="vq__quoteAddressBar">
                          <div className="vq__address vq__address--toggle">
                            <i className="icon-location" />
                            <span className="vq__addressLine">
                              <span className={`vq__addressText${addressAttentionState ? " vq__addressText--updated" : ""}`}>
                                {hasDeliverySelectionChanges && deliveryPick?.id
                                  ? formatAddressListRow(deliveryPick)
                                  : appliedAddressLabel || formatQuotationAddress(quotationData)}
                              </span>
                              {!notesViewOpen ? (
                                <button
                                  type="button"
                                  className="vq__addressIconSlot vq__addressArrowBtn"
                                  onClick={handleDeliverySectionToggle}
                                  aria-expanded={deliverySectionVisible}
                                  aria-controls="vq-delivery-section"
                                  id="vq-delivery-trigger"
                                  disabled={addressDropdownLoading}
                                >
                                  {addressDropdownLoading ? (
                                    <span className="vq__addressChevLoader" />
                                  ) : (
                                    <i
                                      className={`icon-chev-right vq__addressChev vq__addressChev--quote ${deliverySectionVisible ? "vq__addressChev--open" : ""}`}
                                    />
                                  )}
                                </button>
                              ) : null}
                            </span>
                          </div>
                          <div className="vq__quoteHeroActions vq__address vq__address--toggle quote-btn">
                            <button type="button" className="vq__downloadPdfHeader" onClick={() => handelDownloadPdf()}>
                              <img src={downloadButtonIcon} alt="" className="vq__downloadPdfHeader__icon" width={22} height={22} draggable={false} />
                              {LanguageConstants?.DOWNLOAD_PDF}
                            </button>
                            {!notesViewOpen && (quotationData?.status == "1" || quotationData?.status == "0") ? (
                              <button type="button" className="vq__addAnotherHeader" onClick={() => handelAddProduct()}>
                                <span className="vq__addAnotherHeader__icon" aria-hidden>
                                  <i className="icon-add-circle-2" />
                                </span>
                                {LanguageConstants?.ADDMOREPRODUCT}
                              </button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>

                    {deliverySectionVisible && !notesViewOpen ? (
                      <div className="vq__subCard vq-deliveryPanel" id="vq-delivery-section" role="region" aria-labelledby="vq-delivery-trigger">
                        <div className="vq-deliveryPanel__inner">
                          <div className="vq-deliveryPanel__head">
                            <h2 className="vq-deliveryPanel__title">{LanguageConstants?.MANUAL_QUOTE_DELIVERY_SECTION ?? LanguageConstants?.DELADDRESS}</h2>
                            <p className="vq-deliveryPanel__subtitle">{LanguageConstants?.DELIVERYADDRESS}</p>
                          </div>
                          <div className="vq-deliveryPanel__list gap-2" role="radiogroup" aria-label={LanguageConstants?.DELIVERYADDRESS}>
                            {addressRows.map((row: any, i: number) => {
                              const sel = deliveryPick && String(deliveryPick.id) === String(row.id);
                              const rowId = `vq-delivery-addr-${row.id ?? i}`;
                              return (
                                <div key={row.id ?? i} className={` form-check ${sel ? "vq-deliveryPick--selected" : ""}`}>
                                  <input
                                    type="radio"
                                    id={rowId}
                                    name="vq-delivery-pick"
                                    className="vq-deliveryPick__input form-check-input"
                                    checked={Boolean(sel)}
                                    onChange={() => {
                                      setDeliveryPick(row);
                                      setDeliveryNewAddressInline(false);
                                      setDeliverySelectionTouched(true);
                                      setDeliveryUpdateConfirmed(false);
                                      setDeliveryPickError("");
                                      setQuotesEdit(tableQtyStepperUsed);
                                    }}
                                  />
                                  <label className="form-check-label" htmlFor={rowId}>
                                    {formatAddressListRow(row)}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                          {deliveryPickError ? <p className="vq-deliveryPanel__error text-error-new">{deliveryPickError}</p> : null}

                          {!deliveryNewAddressInline ? (
                            <button type="button" className="vq-deliveryPanel__addNew com-btn px-3 mt-2" onClick={() => setDeliveryNewAddressInline(true)}>
                              {LanguageConstants?.NEWADDRES}
                            </button>
                          ) : (
                            <div className="vq-deliveryPanel__embeddedNew">
                              <div className="vq-deliveryPanel__embeddedHead">
                                <span className="vq-deliveryPanel__embeddedTitle vq-deliveryPanel__title">{LanguageConstants?.NEWADDRES}</span>
                                <button type="button" className="vq-deliveryPanel__embeddedCancel" onClick={() => setDeliveryNewAddressInline(false)}>
                                  {LanguageConstants?.CANCEL}
                                </button>
                              </div>
                              <NewAddress
                                deliveryPanelInline
                                submitLabel={LanguageConstants?.CONFIRMA ?? "Confirm"}
                                handleClose={() => setDeliveryNewAddressInline(false)}
                                data={quotationView?.data?.data}
                                onAddressCreated={(newAddrId: string | number) => {
                                  setDeliveryNewAddressInline(false);
                                  if (newAddrId != null && newAddrId !== "") {
                                    setPendingCreatedAddressId(String(newAddrId));
                                    setDeliverySectionVisible(true);
                                    addressListDelivery.makeRequest({ url: ApiConstants?.AddressList, toastStatus: false });
                                  }
                                }}
                              />
                            </div>
                          )}

                          <div className="vq-deliveryPanel__ship">
                            <h3 className="vq-deliveryPanel__title">
                              {LanguageConstants?.MANUAL_QUOTE_SHIPPING_METHOD_SECTION ?? "Shipping Method"}
                            </h3>
                            <p className="vq-deliveryPanel__subtitle">{LanguageConstants?.SHIPPINGMETHOD ?? "Shipping Method"}</p>
                            <div className="vq-deliveryPanel__shipOptions">
                              {shippingRows.map((item) => (
                                <label key={item.refId} className="vq-deliveryPanel__shipOpt">
                                  <input
                                    type="radio"
                                    name="vq-delivery-ship-method"
                                    value={item.refId}
                                    checked={deliveryShippingPick === item.refId}
                                    onChange={(e) => {
                                      setDeliveryShippingPick(e.target.value);
                                      setDeliverySelectionTouched(true);
                                      setDeliveryUpdateConfirmed(false);
                                      setQuotesEdit(tableQtyStepperUsed);
                                    }}
                                  />
                                  <span>{item.name}</span>
                                </label>
                              ))}
                            </div>
                          </div>

                          {quotationData?.status == "1" || quotationData?.status == "0" ? (
                            <div className="vq-deliveryPanel__actions">
                              {!hasDeliverySelectionChanges ? (
                                <button
                                  type="button"
                                  className="manual-quote-btn com-btn rounded-pill"
                                  onClick={() => {
                                    setDeliverySectionVisible(false);
                                    setDeliveryPickError("");
                                    setDeliverySelectionTouched(false);
                                    setDeliveryNewAddressInline(false);
                                  }}
                                >
                                  {LanguageConstants?.CANCEL ?? "Cancel"}
                                </button>
                              ) : null}
                              <span
                                className={deliveryNewAddressInline ? "d-inline-block" : undefined}
                                title={
                                  deliveryNewAddressInline
                                    ? getFromStorage({ key: StorageConstant?.Translate }) === "spa"
                                      ? "Cierre la sección de nueva dirección para continuar"
                                      : "Close the new address section to continue"
                                    : undefined
                                }
                              >
                                <button
                                  type="button"
                                  className="manual-quote-btn com-btn rounded-pill vq-deliveryPanel__continue"
                                  onClick={() => {
                                    if (deliveryNewAddressInline || addressDeliveryUpdate?.loading) return;
                                    if (hasDeliverySelectionChanges) handleDeliveryAddressApply();
                                  }}
                                  disabled={
                                    !hasDeliverySelectionChanges ||
                                    Boolean(addressDeliveryUpdate?.loading) ||
                                    deliveryNewAddressInline
                                  }
                                  style={deliveryNewAddressInline ? { pointerEvents: "none" } : undefined}
                                >
                                  {addressDeliveryUpdate?.loading ? (
                                    <span className="vq-deliveryPanel__btnLoading" aria-live="polite">
                                      <span className="vq-deliveryPanel__btnSpinner" aria-hidden />
                                      {"Loading..."}
                                    </span>
                                  ) : (
                                    LanguageConstants?.CONFIRMA ?? "Confirm"
                                  )}
                                </button>
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </aside>

                  {!notesViewOpen && viewMode === "grid" ? (
                    <section className="vq__rightCol">
                      <div className={`vq__panelScroll vq__fade ${quotationView.loading ? "vq__itemsInner--dim" : ""}`} key={`grid-${viewMode}`}>
                      <div className={isItemSearchActive ? "vq__searchMode" : undefined}>
                        <QuotationItemsToolbar
                          itemSearch={itemSearch}
                          onItemSearchChange={setItemSearch}
                          viewMode={viewMode}
                          onViewModeChange={setViewMode}
                          searchActive={isItemSearchActive}
                          resultCount={filteredRows.length}
                          loading={quotationView.loading}
                        />
                        {isItemSearchActive ? (
                          <div className="vq__searchModeBody">
                            <div className="vq__searchResults">
                              {filteredRows.length === 0 ? (
                                <p className="vq__empty vq__empty--inSearch">{LanguageConstants?.VIEW_QUOTE_NO_ITEMS}</p>
                              ) : (
                                quotationSearchItemCards
                              )}
                            </div>
                          </div>
                        ) : totalItemCount === 0 ? (
                          <p className="vq__empty">{LanguageConstants?.VIEW_QUOTE_NO_ITEMS_AT_ALL}</p>
                        ) : (
                          <div className="vq__cardStack">{quotationSearchItemCards}</div>
                        )}
                      </div>
                        {tableQtyEditingQuoteId != null ? (
                          <div
                            className={`vq__tableEditBar mt-0 p-3 ${
                              tableQtyStepperUsed || hasPendingAddedItems || hasPendingDeletedItems || (deliveryUpdateConfirmed && hasDeliverySelectionChanges)
                                ? ""
                                : " vq__tableEditBar--cancelOnly"
                            }`}
                            role="toolbar"
                            aria-label={LanguageConstants?.EDIT_QUANTITY ?? "Edit quantity"}
                          >
                            <button type="button" className="manual-quote-btn manual-quote-btn--muted com-btn rounded-pill" onClick={() => handleAllQuoteEditCancel()}>
                              {LanguageConstants?.CANCEL ?? "Cancel"}
                            </button>
                            {tableQtyStepperUsed || hasPendingAddedItems || hasPendingDeletedItems || (deliveryUpdateConfirmed && hasDeliverySelectionChanges) ? (
                              <button type="button" className="manual-quote-btn com-btn rounded-pill" onClick={() => handelUpdate()}>
                                {LanguageConstants?.UPDATE ?? "Update"}
                              </button>
                            ) : null}
                          </div>
                        ) : null}
                        {(quotationData?.status == "1" || quotationData?.status == "0") &&
                        ((deliveryUpdateConfirmed && hasDeliverySelectionChanges) || hasPendingAddedItems || hasPendingDeletedItems) &&
                        tableQtyEditingQuoteId == null ? (
                          <div
                            className="vq__tableEditBar mt-0 py-3"
                            role="toolbar"
                            aria-label={LanguageConstants?.CHANGE_ADDRESS ?? "Change Address"}
                          >
                            <button type="button" className="manual-quote-btn manual-quote-btn--muted com-btn rounded-pill" onClick={handleAllQuoteEditCancel}>
                              {LanguageConstants?.CANCEL ?? "Cancel"}
                            </button>
                            <button type="button" className="manual-quote-btn com-btn rounded-pill" onClick={() => handelUpdate()}>
                              {LanguageConstants?.UPDATE ?? "Update"}
                            </button>
                          </div>
                        ) : null}
                        {renderQuotedGridCta()}
                      </div>
                      {renderQuotedApproveAndBreakdown("grid")}
                      <div className={`vq__itemsInner ${quotationView.loading ? "vq__itemsInner--dim" : ""}`}>
                        {(quotationData?.status == "1" || quotationData?.status == "0") && quotesEdit && tableQtyEditingQuoteId == null && !hasDeliverySelectionChanges && !hasPendingAddedItems && !hasPendingDeletedItems ? (
                          <button
                            className="com-btn cursor-pointer head-quote-btn"
                            type="button"
                            onClick={() => handelUpdate()}
                            style={{ marginTop: "6px" }}
                          >
                            {LanguageConstants?.EDITQUANTITY}
                          </button>
                        ) : null}
                      </div>
                    </section>
                  ) : !notesViewOpen ? (
                    <section className="vq__listSection">
                      <div className={isItemSearchActive ? "vq__searchMode" : undefined}>
                        <QuotationItemsToolbar
                          itemSearch={itemSearch}
                          onItemSearchChange={setItemSearch}
                          viewMode={viewMode}
                          onViewModeChange={setViewMode}
                          searchActive={isItemSearchActive}
                          resultCount={filteredRows.length}
                          loading={quotationView.loading}
                          listSection
                        />
                        {isItemSearchActive ? (
                          <div className="vq__searchModeBody">
                            {filteredRows.length === 0 ? (
                              <p className="vq__empty vq__empty--inSearch">{LanguageConstants?.VIEW_QUOTE_NO_ITEMS}</p>
                            ) : (
                              <div className="vq__searchResultsTable">
                                <QuotationItemsTable
                                  rows={filteredRows}
                                  getBrandForRow={getBrandForRow}
                                  canEditRow={Boolean(canEditRow)}
                                  anotherBlocks={anotherBlocks}
                                  tableQtyEditingQuoteId={tableQtyEditingQuoteId}
                                  isQuotedView={isQuotedView}
                                  renderQtyControl={renderQtyControl}
                                  formatQuotedMoneyCell={formatQuotedMoneyCell}
                                  formatQuotedEtaCell={formatQuotedEtaCell}
                                  handleRowQtyEdit={handleRowQtyEdit}
                                  onDeleteLine={onDeleteQuotationLine}
                                />
                              </div>
                            )}
                          </div>
                        ) : (
                        <>
                      <div className={`vq__fade ${quotationView.loading ? "vq__itemsInner--dim" : ""}`} key={`list-${viewMode}`}>
                        {totalItemCount === 0 ? (
                          <p className="vq__empty">{LanguageConstants?.VIEW_QUOTE_NO_ITEMS_AT_ALL}</p>
                        ) : (
                          <QuotationItemsTable
                            rows={filteredRows}
                            getBrandForRow={getBrandForRow}
                            canEditRow={Boolean(canEditRow)}
                            anotherBlocks={anotherBlocks}
                            tableQtyEditingQuoteId={tableQtyEditingQuoteId}
                            isQuotedView={isQuotedView}
                            renderQtyControl={renderQtyControl}
                            formatQuotedMoneyCell={formatQuotedMoneyCell}
                            formatQuotedEtaCell={formatQuotedEtaCell}
                            handleRowQtyEdit={handleRowQtyEdit}
                            onDeleteLine={onDeleteQuotationLine}
                          />
                        )}
                      </div>
                        </>
                        )}
                      </div>
                      {tableQtyEditingQuoteId != null ? (
                        <div
                          className={`vq__tableEditBar mt-0 py-3 p-bottom ${
                            tableQtyStepperUsed || hasPendingAddedItems || hasPendingDeletedItems || (deliveryUpdateConfirmed && hasDeliverySelectionChanges)
                              ? ""
                              : " vq__tableEditBar--cancelOnly"
                          }`}
                          role="toolbar"
                          aria-label={LanguageConstants?.EDIT_QUANTITY ?? "Edit quantity"}
                        >
                          <button type="button" className="manual-quote-btn manual-quote-btn--muted com-btn rounded-pill" onClick={() => handleAllQuoteEditCancel()}>
                            {LanguageConstants?.CANCEL ?? "Cancel"}
                          </button>
                          {tableQtyStepperUsed || hasPendingAddedItems || hasPendingDeletedItems || (deliveryUpdateConfirmed && hasDeliverySelectionChanges) ? (
                            <button type="button" className="manual-quote-btn com-btn rounded-pill" onClick={() => handelUpdate()}>
                              {LanguageConstants?.UPDATE ?? "Update"}
                            </button>
                          ) : null}
                        </div>
                      ) : null}
                      {(quotationData?.status == "1" || quotationData?.status == "0") &&
                      ((deliveryUpdateConfirmed && hasDeliverySelectionChanges) || hasPendingAddedItems || hasPendingDeletedItems) &&
                      tableQtyEditingQuoteId == null ? (
                        <div
                          className="vq__tableEditBar mt-0 py-3"
                          role="toolbar"
                          aria-label={LanguageConstants?.CHANGE_ADDRESS ?? "Change Address"}
                        >
                          <button type="button" className="manual-quote-btn manual-quote-btn--muted com-btn rounded-pill" onClick={handleAllQuoteEditCancel}>
                            {LanguageConstants?.CANCEL ?? "Cancel"}
                          </button>
                          <button type="button" className="manual-quote-btn com-btn rounded-pill" onClick={() => handelUpdate()}>
                            {LanguageConstants?.UPDATE ?? "Update"}
                          </button>
                        </div>
                      ) : null}
                      {renderQuotedApproveAndBreakdown("list")}
                      <div className={`vq__itemsInner ${quotationView.loading ? "vq__itemsInner--dim" : ""}`}>
                        {(quotationData?.status == "1" || quotationData?.status == "0") && quotesEdit && tableQtyEditingQuoteId == null && !hasDeliverySelectionChanges && !hasPendingAddedItems && !hasPendingDeletedItems ? (
                          <button
                            className="com-btn cursor-pointer head-quote-btn"
                            type="button"
                            onClick={() => handelUpdate()}
                            style={{ marginTop: "10px" }}
                          >
                            {LanguageConstants?.EDITQUANTITY}
                          </button>
                        ) : null}
                      </div>
                    </section>
                  ) : (
                    <section className="vq__notesPage" aria-label={LanguageConstants?.VIEW_QUOTE_NOTES_TITLE ?? "Notes"}>
                      <div className="vq__notesTableWrap vq__notesTableWrap--full">
                        {quotationNotes?.loading ? (
                          <p className="vq__notesEmpty">Loading...</p>
                        ) : adminNoteItems.length === 0 ? (
                          <p className="vq__notesEmpty">{LanguageConstants?.VIEW_QUOTE_NOTES_EMPTY}</p>
                        ) : (
                          <table className="vq__notesTable table-bordered">
                            <thead>
                              <tr>
                                <th className="vq__notesTableNum">{LanguageConstants?.Item ?? "Item"}</th>
                                <th className="text-nowrap">{LanguageConstants?.MANUAL_QUOTE_REVIEW_PART_NUMBER ?? "Part Number"}</th>
                                <th className="vq__notesTableLargeCol">{LanguageConstants?.Description ?? "Description"}</th>
                                <th className="vq__notesTableLargeCol">{LanguageConstants?.VIEW_QUOTE_NOTES_COMMENTS ?? "Comments"}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {adminNoteItems.map((it: any) => {
                                const note =
                                  it?.notes != null ? String(it.notes).trim() : "";
                                if (!note) return null;
                                const displayNo = it?.item ?? "—";
                                return (
                                  <tr
                                    key={`notes-row-${displayNo}-${it?.quote_id ?? it?.part_number ?? "x"}`}
                                    className="vq__notesTableRow--hasNote"
                                  >
                                    <td className="vq__notesTableNum">{displayNo}</td>
                                    <td>{it?.part_number || "—"}</td>
                                    <td>{it?.description || "—"}</td>
                                    <td className="vq__notesTableComment--highlight">
                                      {note}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        )}
                      </div>
                      <div className="vq__notesPageActions">
                        <button
                          type="button"
                          className="manual-quote-btn manual-quote-btn--muted com-btn rounded-pill"
                          onClick={closeNotesView}
                        >
                          {LanguageConstants?.BACK ?? "Back"}
                        </button>
                      </div>
                    </section>
                  )}
                </div>
              ) : quotationFetchSettled && !quotationReady ? (
                <p className="vq__empty">{LanguageConstants?.DATANOTFOUND ?? "Unable to load this quotation."}</p>
              ) : null}

              {quotationView?.status &&
              quotationData &&
              quotationData?.total_amount &&
              quotationData?.status != "0" &&
              quotationData?.status != "1" &&
              quotationData?.status != "2" &&
              quotationData?.status != "3" ? (
                <div className="vq-summary card-box mb-5 mt-3">
                  <div className="row">
                    <div className="col-md-6 quote-mid-col py-0 border-0">
                      <div className="provide-quotation-wrap quote-card-box">
                        <div className="quote-mid">
                          <h3 className="quote-ttl">{LanguageConstants?.PROVIDEDQUOTATION}</h3>
                          <div className="table-responsive ">
                            <table className="table">
                              <tbody>
                                <tr>
                                  <td>{LanguageConstants?.TOTALPRODUCTAMOUNT}</td>
                                  <th>
                                    {CurrencyIcon(currency)}
                                    {getPriceHelper(CurrencyConvertHistory(quotationData?.total_product_price, currency))}{" "}
                                  </th>
                                </tr>
                                <tr>
                                  <td>{LanguageConstants?.TOTALSHIIPNGAMOUNT}</td>
                                  <th>
                                    {CurrencyIcon(currency)}
                                    {getPriceHelper(CurrencyConvertHistory(quotationData?.total_shipping_price, currency))}{" "}
                                  </th>
                                </tr>
                                <tr>
                                  <td>
                                    {LanguageConstants?.OTHER} {LanguageConstants?.CHARGES}
                                  </td>
                                  <th>
                                    {" "}
                                    {CurrencyIcon(currency)}
                                    {getPriceHelper(CurrencyConvertHistory(quotationData?.other_charges, currency))}{" "}
                                  </th>
                                </tr>
                                {quotationData?.charges_reason ? (
                                  <tr>
                                    <td>{LanguageConstants?.Charges_reason}</td>
                                    <th>{quotationData?.charges_reason}</th>
                                  </tr>
                                ) : null}
                                <tr>
                                  <td>{LanguageConstants?.TOTALTAX}</td>
                                  <th>
                                    {CurrencyIcon(currency)}
                                    {getPriceHelper(CurrencyConvertHistory(getTaxValue(quotationData), currency))}{" "}
                                  </th>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td className="fw-bold">{LanguageConstants?.GRANDTOTAL}</td>
                                  <td className="text-end fw-bold">
                                    {CurrencyIcon(currency)}
                                    {getPriceHelper(CurrencyConvertHistory(quotationData?.total_amount, currency))}{" "}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2}>
                                    <p style={{ color: "red", margin: 0 }}>{LanguageConstants?.PRIZEMESSAGE}</p>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>

                        <div className="quote-foot vq-quote-foot">
                          <label className="form-check-label vq-quote-foot__label" htmlFor="vq-quote-currency">
                            {LanguageConstants?.VIEW_QUOTE_CURRENCY ?? "Currency"}
                          </label>
                          <select
                            id="vq-quote-currency"
                            className="form-select vq-quote-currency-select"
                            value={currency}
                            onChange={(e) => setCurrency(e.target.value as "USD" | "PHP" | "EUR")}
                            aria-label={LanguageConstants?.VIEW_QUOTE_CURRENCY ?? "Currency"}
                          >
                            <option value="USD">USD ($)</option>
                            <option value="EUR">EUR (€)</option>
                            <option value="PHP">PHP</option>
                          </select>
                        </div>
                        {canShowApproveCta ? (
                          <div className="quote-foot-btns">
                            {/* <button className="reject-approve-btn reject" type="button" onClick={() => handelReject()}>
                              {LanguageConstants?.Reject}
                            </button> */}
                            <button
                              className="reject-approve-btn"
                              type="button"
                              onClick={() => handleCheckout()}
                              disabled={approveNavigating}
                              aria-busy={approveNavigating}
                            >
                              {LanguageConstants?.Approve}
                            </button>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </PageLoadingShell>

      <Modal
        show={otherChargesModalOpen}
        onHide={() => setOtherChargesModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {LanguageConstants?.VIEW_QUOTE_OTHER_CHARGES_TITLE ?? "Other Charges Breakdown"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="vq__otherChargesModal">
            {otherChargesLines.length > 0 ? (
              <ul className="vq__otherChargesModal__list">
                {otherChargesLines.map((line, idx) => (
                  <li key={`${line.label}-${idx}`} className="vq__otherChargesModal__row">
                    <span className="vq__otherChargesModal__label">{line.label}</span>
                    <span className="vq__otherChargesModal__amt">
                      {CurrencyIcon(currency)}
                      {getPriceHelper(
                        CurrencyConvertHistory(parseChargeLineAmount(line.amount), currency),
                      )}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="vq__otherChargesModal__empty">
                {LanguageConstants?.VIEW_QUOTE_OTHER_CHARGES_EMPTY ??
                  "No itemized charges recorded."}
              </p>
            )}
            <div className="vq__otherChargesModal__total">
              <span>{LanguageConstants?.OTHER} {LanguageConstants?.CHARGES}</span>
              <span className="vq__otherChargesModal__totalAmt">
                {CurrencyIcon(currency)}
                {getPriceHelper(CurrencyConvertHistory(otherChargesTotal, currency))}
              </span>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showNotesModal} onHide={() => setShowNotesModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{LanguageConstants?.VIEW_QUOTE_NOTES_TITLE}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: "pre-wrap" }}>
          {adminNoteItems.length
            ? adminNoteItems.map((it: any) => it?.notes).filter(Boolean).join("\n\n")
            : LanguageConstants?.VIEW_QUOTE_NOTES_EMPTY}
        </Modal.Body>
      </Modal>

      <Modal show={showMessage}>
        <QuotationEditMessage handleClose={CloseMessageModal} data={sendData} setEditShow={setEditShow} quotes={quotes} />
      </Modal>

      <Modal show={editshow}>
        <QuotationEdit
          s_no={s_no}
          modalOpen={editshow}
          handleClose={CloseEditModal}
          requestClose={confirmCloseEditQuantityModal}
          data={sendData}
          setQuotesEdit={setQuotesEdit}
          setQuotes={setQuotes}
          quotes={quotes}
          setPendingAnotherProduct={setPendingAnotherProduct}
        />
      </Modal>

      <Modal show={productdelete}>
        <Productdelete
          s_no={s_no}
          setProductDelete={setProductDelete}
          data={sendData}
          onConfirmLocalDelete={confirmLocalProductDelete}
        />
      </Modal>

      <Modal show={chatshow}>
        <ChatModal data={quotationView?.data?.data} setChatshow={setChatshow} />
      </Modal>

      <Modal show={historyShow}>
        <QuantityHistory data={historyData} setHistoryShow={setHistoryShow} />
      </Modal>
    </>
  );
}

export default MyquotationView;
